<template>
  <div class="content" :style="navbarWithName ? 'margin-left: 150px !important; margin-right: auto !important;' : ''"> <!--note: mt,mb,ml,mr(margin) jangan diubah-->
    <v-snackbar v-model="alertSuccess" :timeout="4000" top right color='primary' >
        <v-icon x-medium class="white--text">mdi-checkbox-marked-circle</v-icon>    <span>{{ alert_err_attention }}</span>
    </v-snackbar>
    <v-snackbar v-model="alertFailed" :timeout="4000" top right color='red' >
      <v-icon x-medium class="white--text">mdi-minus-circle</v-icon>   <span>{{ alert_err_attention }}</span>
    </v-snackbar>
    <v-breadcrumbs :items="page" class="ml-2 mt-0 pt-0"></v-breadcrumbs>
      <template >
        <v-toolbar flat class="rounded-lg">
          <v-toolbar-title style="margin-left: 20px;"><v-icon class="mr-2">mdi-earth</v-icon>List {{ this.$store.state.title }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-flex lg3>
            <v-text-field class="pt-3 mr-4" v-model="search" append-icon="mdi-magnify" label="Search"></v-text-field>
          </v-flex>
          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn  v-show=insertact outlined rounded small color="primary" class="mb-2" v-bind="attrs" v-on="on">
                Add New News
                <v-icon class="ml-2">mdi-plus</v-icon>
              </v-btn>
              &nbsp;&nbsp;
              <v-btn  v-show=insertact 
              outlined rounded small color="primary" class="mb-2"
                @click="getnewsfetcher()"
                >
                Add News Fetcher
                <v-icon class="ml-2">mdi-plus</v-icon>
              </v-btn>
            </template>

            <v-card>
              <v-card-title>
                <v-card-title><span class="text-h6">{{ formTitle }}</span></v-card-title>
              </v-card-title>
              <v-card-text style="height: 400px;" class="overflow-card">
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <v-text-field outlined dense v-model="nameNews" :rules="nameNewsRole" label="Name News" 
                      hint="Input name news" persistent-hint>
                      </v-text-field>
                    </v-col>
                    
                    <v-col cols="12" sm="12" md="12">
                      <v-text-field outlined dense v-model="nameDomain" :rules="nameDomainRole" label="Name Domain" 
                      hint="Input name domain" persistent-hint>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                      <v-select dense outlined item-text="name_active" item-value="valueactive" v-model="statusactive" :items="itemsactivate"
                      hint="Activate/Disable crawling news by system" persistent-hint></v-select>
                    </v-col>
                    <v-col> 
                      <!-- <v-file-input dense outlined chips accept="image/*" multiple  type="file" ref="file" label="Include some file" hint="Upload photo"  @change="selectfile"></v-file-input> -->
                      <!-- <input dense outlined chips accept="image/*" type="file"  ref="file" @change="selectfile"> -->
                      <v-file-input
                        outlined
                         v-model="file"
                        dense
                        label="Upload Image"
                        accept="image/*"
                        @change="selectfile"
                        @click:clear="onClear"
                        prepend-icon="mdi-image"
                      ></v-file-input>
                      <v-img v-if="previewImage" :src="previewImage" max-height="200" contain></v-img>
                      
                    </v-col>
                    
                  </v-row>
                </v-container>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions class="py-3">
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" style="width: 90px;" rounded outlined dense @click="close">
                  Cancel
                </v-btn>
                <v-btn color="blue darken-1" style="width: 90px;" rounded dark dense :loading="btnload" @click="save">
                  Save 
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogDelete" width="330px">
            <v-card class="text-center align-center justify-center pa-6 rounded-lg" width="330px">
              <v-avatar class="color-avatar3 my-4" size="62">
                <v-icon x-large class="white--text">mdi-alert-octagon</v-icon>
              </v-avatar>
              <div class="text-center text-h6 align-center justify-center font-weight-medium">
                Confirm Deletion
              </div> 
              <v-card-text class="align-center justify-center mt-2">
                Are you sure you want to permanently delete this item?
              </v-card-text>
              <v-divider class="mt-4" style=""></v-divider>
              <v-card-actions class="align-center justify-center">
                <v-btn rounded class="my-3 btn-ok" width="90px" dark @click="deleteItemConfirm">
                  OK
                </v-btn>
                <v-btn rounded outlined class="my-3" width="90px" color="red" dark @click="closeDelete">
                  Cancel 
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          
          <v-dialog v-model="dialogGenerate" width="330px">
            <v-card class="text-center align-center justify-center pa-6 rounded-lg" width="330px">
              <v-avatar class="color-avatar3 my-4" size="62">
                <v-icon x-large class="white--text">mdi-alert-octagon</v-icon>
              </v-avatar>
              <div class="text-center text-h6 align-center justify-center font-weight-medium">
                Confirm Generate Data Fetcher
              </div> 
              <v-card-text class="align-center justify-center mt-2">
                Are you sure you want to fetch data, there are <b>total {{ countDataFetcher }} data</b> in data fetcher?
              </v-card-text>
              <v-divider class="mt-4" style=""></v-divider>
              <v-card-actions class="align-center justify-center">
                <v-btn rounded class="my-3 btn-ok" width="90px" dark @click="generateNews">
                  OK
                </v-btn>
                <v-btn rounded outlined class="my-3" width="90px" color="red" dark @click="dialogGenerate = false">
                  Cancel 
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogload" persistent max-width="300">
            <v-card>
              <v-card-title class="text-h6 font-weight-medium align-center justify-center">
                Page loading
              </v-card-title>
              <v-card-text class="body-1 align-center justify-center">
                Loading get service, please wait
              </v-card-text>
              <v-card-title class="align-center justify-center">
                <v-progress-circular
                  :size="70"
                  :width="7"
                  color="#0471A5"
                  indeterminate
                ></v-progress-circular>
              </v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#0471A5" text @click="dialogload = false">
                  cancel
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <v-data-table
      :headers="headers"
      :items="medianews"
      :search="search"
      sort-by="nameNews"
      class="table-user ml-6 mr-6 mt-4 rounded-lg"
      :loading="tableLoading"
      loading-text="Loading data..."
      >
      
      
      <!-- Correct slot usage for item.STATUS -->
      <template v-slot:item.STATUS="{ item }">
        <v-chip :color="getColor(item.STATUS)"  text-color="white" label small pill>
          {{ item.STATUS }}
        </v-chip>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small class="mr-2" v-show=updateact @click="editItem(item.SEQ_ID)">
          mdi-pencil
        </v-icon>
        <v-icon small v-show=deleteact @click="deleteItem(item.SEQ_ID)">
          mdi-delete
        </v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">
          Reset
        </v-btn>
      </template>
      <template v-slot:[`item.image`]="{ item }">
        <v-img :src="item.PRS_IMAGE" style="width: 60px;" />
      </template>
    </v-data-table>
        <Notification  ref="alert"></Notification>
  </div>
</template>
<script> 
import Notification from  '@/components/Notification';
import { decryptionData } from '@/components/utils/utils.js';
import axios from "axios";
import { mapGetters } from 'vuex';
  export default {
  components: {
    Notification: Notification
  },
    data: () => ({
      tableLoading : false,

      btnload:false,
      alertSuccess:'',
      alertFailed:'',
      alert_err_attention: "",
      
      deleteact: true,
        insertact: true,
        updateact: true,
        viewact: true,
        
      nameNewsRole: [
          v => !!v || 'Name news is required',
          v => /[a-zA-Z0-9.@_ -]+$/.test(v) || 'Input may contain letters, numbers, spaces, and special characters (.@_-)',
        ],
        
      nameDomainRole: [
          v => !!v || 'Domain is required',
          v => /[a-zA-Z0-9.@_ -]+$/.test(v) || 'Input may contain letters, numbers, spaces, and special characters (.@_-)',
        ],
        // ====================
        // variable input 
        // ====================
        id_news:'',
        nameNews: '',
        status: '',
        previewImage: null,
        statusactive: 1,
        itemsactivate: [//choice select
          {valueactive: 1, name_active: "Active" },
          {valueactive: 0, name_active: "Disable" }
        ],
        countDataFetcher:'',
        dialogload: false,
        dialog: false,
        dialogDelete: false,
        search:'',
        headers: [
          { text: 'Name News', value: 'NAME_NEWS' },
          { text: 'Domain', value: 'DOMAIN' },
          { text: 'Status', value: 'STATUS' },
          { text: 'Image', value: 'image' },
          { text: 'Actions', value: 'actions', sortable: false },
        ],
        medianews: [],
        editedIndex: -1,
        file: "",
        editedItem: {
        },
        defaultItem: {
        },
    }),
    computed: {
      page() {
        return this.$store.state.breadcrumbs
      },
      ...mapGetters(['navbarWithName']), // Accessing navbarWithName from Vuex
      formTitle () {
        return this.editedIndex === -1 ? 'Add News' : 'Update News'
      },
    },
    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },
    created () {
      this.initialize()
    },
    methods: {
      getColor(status) {
        return status === 'Disabled' ? 'red' : 'green';
      },
      
      getnewsfetcher(){
       this.dialogload= true
        axios({
          method: "post",
          url: "news-fetcher",
          data: {
            // id: item
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then(async (response) => {
            let data = decryptionData(response.data.data);
            if (data.status === 404) {
              this.alertFailed = true;
              this.alert_err_attention =  "Service offline, can't get data";
            } else {
              this.countDataFetcher = data.count;
              //console.log(data)
              this.dialogload= false
              this.dialogGenerate= true
            }
            // alert(data.count)
            setTimeout(() =>{
              this.dialogload= false
              // this.dialogGenerate= true


            },1000)
        })
        .catch(function (error) {
              this.dialogload = false
          console.log(error);
        })
      },
      
      generateNews(){
       this.dialogload= true
        axios({
          method: "post",
          url: "news-fetcher-generate",
          data: {
            // id: item
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then(async (response) => {
            let data = decryptionData(response.data.data);
            if (data.status === 404) {
              this.alertFailed = true;
              this.alert_err_attention =  "Service offline, can't get data";
            } else {
            
              this.alertSuccess = true;
              this.alert_err_attention =  "Success Update Data";
              this.initialize()
              this.dialogGenerate= false
              this.dialogload= false
            }
            // alert(data.count)
            setTimeout(() =>{
              
              this.dialogload= false
            },1000)
        })
        .catch(function (error) {
              this.dialogload = false

          console.log(error);
        })
      },
      
      initialize () {
        this.tableLoading = true;
        axios.get("news",
          { headers:{'auth-token':localStorage.getItem('token_app')}},
          {dataType: 'json'}
          ).then((response) => {
            
            this.medianews = decryptionData(response.data.token);
            // this.medianews = response.data;
            console.log(response.data);
            // end loading 
            setTimeout(() =>{
              this.loading = false
            },1000)
            this.tableLoading = false;
            if(localStorage.getItem('authactdeletedt') == 1){ this.deleteact = true }
            if(localStorage.getItem('authactinsert') == 1){ this.insertact = true }
            if(localStorage.getItem('authactupdate') == 1){ this.updateact = true }
            if(localStorage.getItem('authactview') == 1){ this.viewact = true }
          })
          .catch((e) => {
              switch (e.response.status) {
                    case 404:
                          this.$refs.alert.error_login(404);
                        break;
                    case 403:
                          this.$refs.alert.error_login(403);
                        break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                  }
          this.errors=e.response.data.msg;
        });
      },
      deleteItem (item) {
        this.id_news = item
        this.editedIndex = this.medianews.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },
      deleteItemConfirm () {
        this.medianews.splice(this.editedIndex, 1)
        axios({
          method: "delete",
          url: "news/delete",
          data: {
            seq_id: this.id_news
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
          // handle success
          var status = response.data.status
          var messages = response.data.msg
          if(status == 200){
            this.initialize ();
            this.alertSuccess = true;
            this.alert_err_attention =  messages;
            this.closeDelete()
          }else{
              this.alertFailed = true;
              this.alert_err_attention =  messages;
          } 
        })
        .catch(function (error) {
          // handle error
          this.alertFailed = true;
          this.alert_err_attention =  'Delete Failed '+error;
        })
        this.closeDelete()
      },
      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      // selectfile() {
      //   this.file = this.$refs.file.files[0];

      // },
      selectfile(event) {
        this.file = event;
        if (event) {
          const reader = new FileReader();
          reader.onload = (e) => {
            this.previewImage = e.target.result;
          };
          reader.readAsDataURL(event);
        }
      },
      
      onClear() {
        this.previewImage='';
        this.file = null; // bisa juga reset data lainnya jika perlu
      },
      editItem (item) {
        this.id_news = item
        this.editedIndex = 1

        this.editedItem = Object.assign({}, item)
        this.dialog = true
        axios({
          method: "put",
          url: "news_Id",
          data: {
            id: item
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then(async (response) => {
            let data = decryptionData(response.data.token);
            this.id_news = data.SEQ_ID 
            this.nameNews = data.NAME_NEWS 
            this.nameDomain = data.DOMAIN 
            this.statusactive = data.STATUS 
            // this.file ='';
            
        // Ambil file dari URL dan ubah ke File object
            if (data.PRS_IMAGE) {

              const imageUrl = data.PRS_IMAGE;

              try {
                const response = await axios.get(imageUrl, {
                  responseType: 'blob',
                });

                const blob = response.data;
                const filename = imageUrl.split('/').pop();
                const file = new File([blob], filename, { type: blob.type });

                this.file = file;
                this.previewImage = URL.createObjectURL(file); // opsional preview
              } catch (err) {
                console.error("Gagal ambil gambar dari server:", err);
                this.file = null;
                this.previewImage = '';
              }
              // this.file = file;
              // this.previewImage = URL.createObjectURL(file); // tampilkan preview
            } else {
              this.file = null;
              this.previewImage = '';
            }
            setTimeout(() =>{
              this.loading = false
            },1000)
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
      },
      async save () {
        const formData = new FormData();
        formData.append('image', this.file);
        formData.append('seq_id', this.id_news);
        formData.append('nameNews', this.nameNews);
        formData.append('domain', this.nameDomain);
        formData.append('status', this.statusactive);
        for (var item of formData.entries()) {
            console.log(item[0]+ ', ' + item[1]); 
        }
          this.btnload = true

        if (this.editedIndex > -1) {
          await axios.put("news/update",formData, 
            { headers:
              {
                'auth-token':localStorage.getItem('token_app'),
                // 'Content-Type': 'multipart/form-data;boundary=---uuWebKitFormBoundaryg7okV37G7Gfll2hf',
                'Content-Type': 'multipart/form-data',
              }
            },
            {dataType: 'json'},
            
            )
          .then((response) => {
                var status = response.data.status
                var messages = response.data.msg
                if(status == 200){
                  this.initialize();
                  this.$router.push('/medianews');
                  this.alertSuccess = true;
                  this.alert_err_attention =  messages;
                  this.btnload = false
                  this.close()
                }else{
                    this.alertFailed = true;
                    this.alert_err_attention =  messages;
                    this.btnload = false
                } 
            })
          .catch((e) => {
                switch (e.response.status) {
                    case 404:
                          this.$refs.alert.error_login(404);
                        break;
                    case 403:
                          this.$refs.alert.error_login(403);
                        break;
                    case 400:
                          this.alertFailed = true;
                          this.alert_err_attention =  e.response.data.msg;
                        break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                    }
            this.errors=e.response.data.msg;
          });
        } else {
          this.medianews.push(this.editedItem)
          await axios.post("news/insert",formData, 
            { headers:
              {
                'auth-token':localStorage.getItem('token_app'),
                'Content-Type': 'multipart/form-data',
                // 'Content-Type': 'multipart/form-data;boundary=---uuWebKitFormBoundaryg7okV37G7Gfll2hf',
              }
            },
            {dataType: 'json'},
            
            )
          .then((response) => {
                var status = response.data.status
                var messages = response.data.msg
                if(status == 200){
                  this.initialize();
                  this.$router.push('/medianews');
                  this.alertSuccess = true;
                  this.alert_err_attention =  messages;
                  this.btnload = false
                  this.close()
                }else{
                    this.alertFailed = true;
                    this.alert_err_attention =  messages;
                    this.btnload = false
                } 
            })
          .catch((e) => {
                switch (e.response.status) {
                    case 404:
                          this.$refs.alert.error_login(404);
                        break;
                    case 403:
                          this.$refs.alert.error_login(403);
                        break;
                    case 400:
                          this.alertFailed = true;
                          this.alert_err_attention =  e.response.data.msg;
                        break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                    }
            this.errors=e.response.data.msg;
          });
        }
          this.btnload = false

        this.close()
      },
      close () {
        this.file='';
        this.nameNews='';
        this.nameDomain='';
        this.previewImage='';
        this.file = null; // reset setelah submit juga
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      
      
    },
  }
</script>

<style scoped>
.btn-ok{
  background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
}
.v-avatar.color-avatar3
{
  box-shadow: 0 5px 15px rgba(255, 0, 0, 0.4);
  background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
}
</style>